<script>
  import geojson2h3 from "geojson2h3";
  import * as turf from "@turf/turf";
  import * as ss from "simple-statistics";
  import {
    radioCheck,
    isCalculate,
    totalPopulation,
    totalJobs,
    averageAge,
    averageCommute,
    averageWalk,
    averageDeprivation,
    serverURL,
    LoadingBarValue,
    drawClicked,
    topZonesStore,
    lpCoords,
  } from "../../../store.js";

  export let map;

  export let bufferLocation;

  let poly;
  let isTopZonesEnabled = true;

  function toggleTopZones() {
    if (isTopZonesEnabled) {
      var data = map.getSource("box")._data.features;
      const values = data.map((obj) => obj.properties[$radioCheck]);
      values.sort((a, b) => a - b);
      var tz = 1 - $topZonesStore / 100;
      var top10 = ss.quantile(values, [0, tz, 1]);

      map.setPaintProperty("box-layer", "fill-opacity", [
        "case",
        [">=", ["get", $radioCheck], top10[1]],
        0.8,
        0.1,
      ]);
    } else {
      // Toggle is disabled, set a fixed fill-opacity of 0.8
      map.setPaintProperty("box-layer", "fill-opacity", 0.8);
    }

    // Toggle the state for next click
    isTopZonesEnabled = !isTopZonesEnabled;
  }
  function toggleText() {
    if ($isCalculate) {
      LP();
    } else {
      resetScheme();
    }
  }
  function LP() {
    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }

    if (document.getElementsByClassName("mapboxgl-marker").length > 0) {
      getBuffer(turf.point($lpCoords));
    }
  }

  function getBuffer(coords) {
    makeApiRequest(coords.geometry.coordinates).then((geojson) => {
      poly = geojson[0];

      map.addSource("buffer", {
        type: "geojson",
        data: geojson[0],
      });
      map.addLayer(
        {
          id: "buffer",
          type: "fill",
          source: "buffer",
          layout: {},
          paint: {
            "fill-color": "#45bcbb",
            "fill-opacity": 0.3,
          },
        },
        "gl-draw-polygon-fill-inactive.cold"
      );
      calcScheme(poly);
    });

    /*poly = turf.buffer(coords, bufferLocation, { units: "kilometers" });

    map.addSource("buffer", {
      type: "geojson",
      data: poly,
    });

    map.addLayer(
      {
        id: "buffer",
        type: "fill",
        source: "buffer",
        layout: {},
        paint: {
          "fill-color": "#45bcbb",
          "fill-opacity": 0.3,
        },
      },
      "gl-draw-polygon-fill-inactive.cold"
    );

    calcScheme(poly);*/
  }

  function calcScheme(poly) {
    var h3Calc = geojson2h3.featureToH3Set(poly, 10, {
      options: { ensureOutput: true },
    });
    var h3Search;
    var scheme;
    if (turf.area(poly) > 2000000) {
      h3Search = geojson2h3.featureToH3Set(poly, 7, {
        options: { ensureOutput: true },
      });
      scheme = "schemeinfo";
    } else {
      h3Search = h3Calc;
      scheme = "schemeinfo_res10";
    }

    $LoadingBarValue = 1;
    setTimeout(() => {
      $LoadingBarValue = 10;
      fetch(`${$serverURL}api/data/${scheme}?h3=${h3Search}`)
        .then((response) => response.json())
        .then((responseData) => {
          $LoadingBarValue = 50;

          console.log("search Complete");

          const h3_polyfill_res10 = responseData.filter((item) =>
            h3Calc.includes(item.h3_polyfill)
          );

          // Simulate a delay to show progress
          setTimeout(() => {
            $LoadingBarValue = 80;

            const groupedData = h3_polyfill_res10.reduce(
              (accumulator, current) => {
                const key = current.h3_polyfill_res8;

                if (!accumulator[key]) {
                  accumulator[key] = {
                    h3_polyfill_res8: key,
                    totalPopulation: 0,
                    totalJobs: 0,
                  };
                }

                accumulator[key].totalPopulation += current.pop || 0;
                accumulator[key].totalJobs += current.jobs || 0;

                return accumulator;
              },
              {}
            );

            // Simulate a delay to show progress
            setTimeout(() => {
              $LoadingBarValue = 99;

              const groupedArray = Object.values(groupedData);

              // Simulate a delay to show progress
              setTimeout(() => {
                $totalPopulation = groupedArray.reduce(
                  (accumulator, current) => {
                    return accumulator + (current.totalPopulation || 0);
                  },
                  0
                );

                $totalJobs = groupedArray.reduce((accumulator, current) => {
                  return accumulator + (current.totalJobs || 0);
                }, 0);

                // Simulate a delay to show progress
                setTimeout(() => {
                  console.log("jobs and pop complete");
                  $LoadingBarValue = 100;
                  dataSpeedDials("age_15_45", h3_polyfill_res10);
                  dataSpeedDials("lessthan10km", h3_polyfill_res10);
                  dataSpeedDials("bikewalktowork", h3_polyfill_res10);
                  dataSpeedDialsDep("deprived", h3_polyfill_res10);

                  // Final progress update
                }, 200);
              }, 200);
            }, 200);
          }, 200);
        });
    }, 200);

    $isCalculate = false;
  }

  function dataSpeedDials(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
  function dataSpeedDialsDep(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum / tot.count : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
  function resetScheme() {
    $LoadingBarValue = 0;
    if (document.getElementsByClassName("mapboxgl-marker").length > 0) {
      [...document.getElementsByClassName("mapboxgl-marker")].forEach((d) => {
        d.remove();
      });
    }

    if (map.getSource("buffer")) {
      map.removeLayer("buffer");
      map.removeSource("buffer");
    }

    $drawClicked = false;
    const elements = document.getElementsByClassName("schemeResults");

    // Loop through each element and set its opacity to 0
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.opacity = 0;
    }
    $isCalculate = true;
    document
      .querySelectorAll(".triangle")
      .forEach((element) => element.remove());
    $averageCommute = 0;
    $averageAge = 0;
    $averageDeprivation = 0;
    $averageWalk = 0;
    setTimeout(() => {
      $totalPopulation = 0;
      $totalJobs = 0;
    }, 1000);

    setTimeout(() => {
      document.getElementById("insights").value = "LP";
    }, 1);
  }

  function makeApiRequest(coords) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest();

      request.open(
        "POST",
        "https://api.openrouteservice.org/v2/isochrones/cycling-regular"
      );

      request.setRequestHeader(
        "Accept",
        "application/json, application/geo+json, application/gpx+xml, img/png; charset=utf-8"
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader(
        "Authorization",
        "5b3ce3597851110001cf6248cd2339cc5b584fdfb63421699634ae63"
      );

      const body = JSON.stringify({
        locations: [coords],
        range: [bufferLocation * 1000], // Assuming the input is in minutes, convert to seconds
        range_type: "distance",
      });
      request.send(body);

      request.onreadystatechange = function () {
        if (this.readyState === 4) {
          console.log("Status:", this.status);
          console.log("Headers:", this.getAllResponseHeaders());
          if (this.status === 200) {
            var geojson = JSON.parse(this.responseText);
            resolve(geojson.features);
          } else {
            console.error("Error:", this.statusText);
            reject(new Error(`Request failed with status ${this.status}`));
          }
        }
      };
    });
  }
</script>

<!-- <button
  class="topZones"
  style="opacity: {$topZonesStore > 0 ? 1 : 0};"
  on:click={toggleTopZones}
>
  Toggle Top Zones</button
>-->
<button class="calcScheme" id="calcScheme_LP" on:click={toggleText}>
  {$isCalculate ? "Calculate" : "Reset"}
</button>

<style>
  .calcScheme {
    position: absolute;
    font-size: 12px;
    bottom: 0px;
    right: 0px;
    margin: 10px;
    border-radius: 10px;
  }
  .topZones {
    position: absolute;
    font-size: 12px;
    bottom: 0px;
    left: 0px;
    margin: 10px;
    border-radius: 10px;
  }
</style>
